import { useEffect, useState } from "react";
import { Button, Modal, useTheme } from "@mui/material";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { CustomBox } from "@/common/StyledComponents";
import { ActualLines, ActualLinesWithHeader } from "./ActualLines";
import {
    closeLinesPopup,
    selectChecksAreValid,
    selectLinesPopupOpen,
    startAllocation,
} from "./actualSlice";

export default function ActualLinesPopup({ bids, customLinesGroup }) {
    const [keepMounted, setKeepMounted] = useState(false);
    const dispatch = useDispatch();
    const open = useSelector(selectLinesPopupOpen);
    const checksAreValid = useSelector(selectChecksAreValid);
    const theme = useTheme();
    const handleAllocate = () => {
        dispatch(startAllocation());
    };
    const handleClose = () => {
        dispatch(closeLinesPopup());
    };

    useEffect(() => {
        // NOTE: this prevents blocking the parent from rendering while this component is mounting
        setKeepMounted(true);
    }, []);

    return (
        <Modal keepMounted={keepMounted} open={open} onClose={handleClose}>
            <CustomBox
                maxHeight={"90vh"}
                width={"80%"}
                overflow={"auto"}
                padding={0}
                sx={{
                    paddingLeft: 4,
                    paddingRight: 4,
                    background: theme.palette.background.default,
                }}
            >
                <ActualLinesWithHeader
                    selectable={true}
                    bids={bids}
                    customLinesGroup={customLinesGroup}
                />
                <div
                    style={{
                        width: "100%",
                        textAlign: "right",
                        position: "sticky",
                        bottom: -25,
                        background: theme.palette.background.default,
                        paddingBottom: 20,
                        paddingTop: 20,
                    }}
                >
                    <Button
                        disabled={!checksAreValid}
                        onClick={handleAllocate}
                        variant="contained"
                    >
                        Assign to Bill(s)
                    </Button>
                </div>
            </CustomBox>
        </Modal>
    );
}
